export const measureText = (text: string): { width: number; height: number } => {
	const el = document.createElement("div")
	document.body.appendChild(el)

	// TODO: style 適当なので修正する
	el.style.fontSize = "1rem"
	el.style.fontWeight = "700"
	el.style.margin = "0"
	el.style.padding = "0.5rem"
	el.style.position = "absolute"
	el.style.left = "-1000"
	el.style.top = "-1000"
	el.innerHTML = text
	const result = {
		width: el.clientWidth,
		height: el.clientHeight,
	}
	document.body.removeChild(el)
	return result
}

export function escapeRegExp(value: string) {
	return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}
